import React from 'react';
import GoogleMapReactComponent, { Props } from 'google-map-react';
const GoogleMapReact = (props: Props) => {
  const LocalGoogleMapReact = GoogleMapReactComponent as unknown as React.ComponentType<Props>;

  return <LocalGoogleMapReact {...props} />;
};

export default GoogleMapReact;
